module.exports = {
    showNewsSliderOnTournamentsPage: process.env.SHOW_NEWS_SLIDER_ON_TOURNAMENTS_PAGE === 'true',
}